const Accordion = (() => {

    const DOM = {};

    const cacheDOM = () => {
        DOM.head = document.querySelectorAll('.content__accordion-column--header');
        DOM.body = document.querySelectorAll('.content__accordion-column--body');
    };

    const onLoad = () => {
        window.addEventListener('load', function () {
            Array.from(DOM.body).forEach((element) => {
                element.classList.add('accordion-closed');
                element.setAttribute('style', `height: 0`);
            });
        })
    };

    const eventListener = () => {
        Array.from(DOM.head).forEach((element) => {
            element.addEventListener('click', toggleAccordion);
        });
    };

    function toggleAccordion(event) {
        event.preventDefault();
        const head = event.currentTarget;
        const body = head.nextElementSibling;
        if (body.classList.contains('accordion-open')) {
            body.classList.add('accordion-closed');
            body.classList.remove('accordion-open');
            body.setAttribute('style', `height: 0`);
            head.classList.remove('header-clicked');
        } else {
            Array.from(DOM.body).forEach(element => {
                element.classList.add('accordion-closed');
                element.classList.remove('accordion-open');
                element.setAttribute('style', `height: 0`);
            });
            Array.from(DOM.head).forEach(element => {
                element.classList.remove('header-clicked');
            });
            body.classList.remove('accordion-closed');
            body.classList.add('accordion-open');
            body.setAttribute('style', `height: ${body.scrollHeight}px`);
            head.classList.add('header-clicked');
        }
    }

    const init = () => {
        cacheDOM();
        onLoad();
        eventListener();

    };

    return {
        init

    }
})();

export default Accordion;
